import React, { useState } from "react";
import { createFile, getWatermarkedImgixUrl, updateUser } from "services";
import {
  IconTitleDescriptionActionCard,
  SectionContainerBase,
  TwoColumnSectionBase,
  ButtonBase,
  LazyLoadedImage,
  FileUploaderBase,
} from "@reusejs/react";
import { useSelector } from "react-redux";
import CloudUpload from "../../../Icons/CloudUpload";
import Loader from "../../../layouts/Loader";

export default function ProfileImage() {
  const [loading, setLoading] = useState(false);

  const userUuid = useSelector((state: any) => {
    return state.auth?.user?.uuid;
  });

  const userEmail = useSelector((state: any) => {
    return state.auth.userEmail;
  });

  const userProfile = useSelector((state: any) => {
    return state.auth?.user?.profile;
  });

  const genarateName = () => {
    if (userProfile?.bio?.first_name && userProfile?.bio?.last_name) {
      return (
        userProfile?.bio?.first_name.charAt(0).toUpperCase() +
        userProfile?.bio?.first_name.slice(1) +
        " " +
        userProfile?.bio?.last_name
      );
    } else if (userProfile?.bio?.first_name) {
      return (
        userProfile?.bio?.first_name.charAt(0).toUpperCase() +
        userProfile?.bio?.first_name.slice(1)
      );
    } else {
      return userEmail;
    }
  };

  let sectionDetails = {
    title: genarateName(),
    description: userProfile?.bio?.role ? userProfile.bio.role : "",
  };

  const handleUploadImage = async (file: any) => {
    try {
      if (file) {
        setLoading(true);
        const data: any = await createFile(file.file, {
          owner_identifier: userUuid,
          owner_service: "user-profile",
        });
        if (!data.key_path) {
          throw new Error("Failed to Upload file");
        }
        const payload = {
          ...userProfile,
          profile_picture: data.key_path,
        };
        const profileData: any = await updateUser(payload);
        if (profileData) {
          setLoading(false);
        }
      }
    } catch (error) {
      console.log("ProfileImage -> handleUploadImage -> check error:", error);
    }
  };

  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: "bg-white overflow-hidden py-10 md:py-10",
        innerContainerStyles: "max-w-sm",
      }}
    >
      <TwoColumnSectionBase
        firstColumnEl={
          <div className="relative rounded-lg overflow-hidden">
            <div className="relative overflow-hidden h-28 w-28 shadow-md">
              {userProfile?.profile_picture ? (
                <LazyLoadedImage
                  src={getWatermarkedImgixUrl(
                    `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${userProfile?.profile_picture}?fit=crop&w=112&h=112&auto=format`,
                  )}
                  placeholderSrc={getWatermarkedImgixUrl(
                    `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/e07803a8-7771-4c1d-8128-f2580524bd03?fit=crop&w=112&h=112&auto=format`,
                  )}
                  width={112}
                  height={112}
                />
              ) : (
                <LazyLoadedImage
                  src={getWatermarkedImgixUrl(
                    `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/e07803a8-7771-4c1d-8128-f2580524bd03?fit=crop&w=112&h=112&auto=format`,
                  )}
                  width={112}
                  height={112}
                />
              )}
              {loading && (
                <>
                  <div className="absolute h-28 w-28 top-0 bg-gray-50 opacity-40" />
                  <div className="absolute h-28 w-28 top-0 flex justify-center items-center">
                    <Loader height="h-10" width="w-10" color="text-blue-600" />
                  </div>
                </>
              )}
            </div>
          </div>
        }
        secondColumnEl={
          <IconTitleDescriptionActionCard
            title={sectionDetails.title}
            description={sectionDetails.description}
            actions={
              <FileUploaderBase
                accept="*/*"
                multiple={false}
                upload={(file: any) => {
                  return new Promise((resolve, reject) => {
                    resolve({ name: file.name });
                  });
                }}
                selectedFiles={(selectedFiles: any) => {
                  console.log("selectedFiles", selectedFiles);
                  handleUploadImage(selectedFiles[0]);
                }}
                beforeUpload={(uploadedFiles: any) => {
                  console.log("beforeUpload", uploadedFiles);
                }}
                afterUpload={(uploadedFiles: any) => {
                  console.log("afterUpload", uploadedFiles);
                  alert("picture uploaded!");
                }}
                openFileUploader={(triggerClickHandler: () => void) => (
                  <ButtonBase
                    variant="primary"
                    type="submit"
                    label={"Change picture"}
                    onClick={() => triggerClickHandler()}
                    buttonPrefix={
                      <div className="mr-2">
                        <CloudUpload />
                      </div>
                    }
                    buttonBaseClasses={{
                      font: "text-xs font-medium",
                      backgroundColor: "bg-blue-600 hover:bg-blue-700",
                      textColor: "text-white",
                      border: "any",
                      padding: "px-2 py-2",
                    }}
                  />
                )}
              />
            }
            itemTitleDescriptionCardBaseClasses={{
              titleWrapper: "text-left",
              titleStyles:
                "text-2xl font-bold text-gray-900 sm:leading-none sm:tracking-tight",
              descriptionWrapper: "text-left mt-1",
              descriptionStyles: "text-base font-normal text-gray-500",
              actionWrapper: "mt-3",
            }}
          />
        }
        twoColumnSectionBaseClasses={{
          firstElWrapperStyles:
            "w-1/3 overflow-hidden flex justify-center items-center",
          secondElWrapperStyles: "w-2/3 self-stretch pl-2 flex items-center",
          columnsFlexWrapperStyles: "flex items-center justify-center",
        }}
      />
    </SectionContainerBase>
  );
}
